import logo from '../assets/images/logo.png';

const Logo = () => {
  return (
    <img src={logo} alt='logo' className='logo-img' />
  )
}

export default Logo;
